import { z } from 'zod'
import { HostRegion, HostState } from './host-state.js'
import { PublicSeriesRef } from './series-publication.js'
import { PublicShow } from './show-results-release.js'

const Count = z.number().int().nonnegative()
export const PublicAtlasResponse = z.strictObject({
  totals: z.strictObject({
    entries: Count,
    shows: Count,
    series: Count,
    entrants: Count,
    uniqueEntrants: Count.nullable(),
    modelClassesWithEntries: Count,
    clubs: Count.nullable(),
    classesWithEntries: Count,
  }),
  coverage: z.strictObject({
    clubShows: Count,
    missingClubShows: Count,
    showsWithPublishedSeries: Count,
    showsWithoutPublishedSeries: Count,
    unlinkedClassEntries: Count,
    participantShows: Count,
    missingParticipantShows: Count,
  }),
  period: z.strictObject({ fromYear: Count.nullable(), toYear: Count.nullable() }),
  states: z.array(z.strictObject({ state: HostState, shows: Count, entries: Count })),
  unlocated: z.strictObject({ shows: Count, entries: Count }),
  months: z.array(z.strictObject({ month: z.number().int().min(1).max(12), shows: Count })),
  categories: z.array(z.strictObject({ code: z.string(), name: z.string(), entries: Count })),
  classes: z.array(
    z.strictObject({
      modelClassKey: z.string(),
      name: z.string(),
      entries: Count,
      shows: Count,
      averageEntries: z.number().nonnegative(),
    })
  ),
  regions: z.array(
    z.strictObject({
      region: HostRegion,
      shows: Count,
      light: Count.nullable(),
      amber: Count.nullable(),
      dark: Count.nullable(),
    })
  ),
  series: z.array(PublicSeriesRef.extend({ shows: Count }).strict()),
  championships: z.array(PublicSeriesRef.extend({ shows: Count }).strict()).default([]),
  releasedShows: z.array(
    PublicShow.extend({
      hostState: HostState.nullable(),
      entries: Count,
      releasedAt: z.iso.datetime(),
      series: PublicSeriesRef.nullable(),
    }).strict()
  ),
  // The same name, dates and place the before-release show page exposes.
  unreleasedShows: z.array(PublicShow),
})
export type PublicAtlasOutput = z.infer<typeof PublicAtlasResponse>
